import { createRoutine } from 'redux-saga-routines';

export const fetchCurrentPantry = createRoutine('FETCH_CURRENT_PANTRY');

export const createPantry = createRoutine('CREATE_PANTRY');

export const updatePantry = createRoutine('UPDATE_PANTRY');

export const fetchPortalUsers = createRoutine('FETCH_PORTAL_USERS');

export const syncPortalUserGuestAddress = createRoutine(
  'SYNC_PORTAL_USER_GUEST_ADDRESS'
);

export const syncPortalUserGuestPhone = createRoutine(
  'SYNC_PORTAL_USER_GUEST_PHONE'
);
